import { useParams } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query';
import useCompanyStatusChange from 'hooks/useCompanyStatusChange';
import {
  useGetCompanyDetailsQuery,
  useGetCompanyPermissionsQuery,
} from 'store/slices/companies/apis/companiesApi';

import CompanyProfileView from './CompanyProfileView';

import type { TCompanyStatus } from 'constants/interfaces';

function CompanyProfile() {
  const { clientId = '' } = useParams();

  const fetchQuery = clientId ? {
    companyId: +clientId,
  } : skipToken;

  const { data: company, isFetching } = useGetCompanyDetailsQuery(fetchQuery);
  const { data: permissions, isFetching: isCompanyPermissionsFetching } = useGetCompanyPermissionsQuery(fetchQuery);

  const {
    isDeactivationModalOpen,
    onToggleDeactivationModal,
    onChangeCompanyStatus,
    onCompanyDeactivate,
    isActionsLoading,
  } = useCompanyStatusChange({
    companyId: +clientId,
    status: company?.data.status as TCompanyStatus,
  });

  const isPageLoading = isFetching || isCompanyPermissionsFetching || isActionsLoading;

  return (
    <CompanyProfileView
      company={company?.data}
      permissions={permissions?.data}
      onChangeCompanyStatus={onChangeCompanyStatus}
      isDeactivateCompanyModalOpen={isDeactivationModalOpen}
      onCloseDeactivateCompanyModal={onToggleDeactivationModal}
      onConfirmDeactivateCompanyModal={onCompanyDeactivate}
      isPageLoading={isPageLoading}
    />
  );
}

export default CompanyProfile;
